// extracted by mini-css-extract-plugin
export default {"mCard":"hD-z","image":"iD-z","imageNoBackground":"jD-z","imageHasCategory":"kD-z","fullWidth":"lD-z"};